// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UIrL","type":"styles_type__v1mDX","choices":"styles_choices__S-nuA"};